module.exports = __webpack_public_path__ + "static/media/photo49.07f79158.jpg";